function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHidei = function SvgHidei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m15.282 6.793 2.266-2.265c.273-.273.716-.273 1 0s.273.717 0 1L5.433 18.623c-.273.273-.717.273-1 0s-.273-.717 0-1l1.63-1.63a10.8 10.8 0 0 1-3.38-3.6.7.7 0 0 1 0-.7 10.796 10.796 0 0 1 12.589-4.909zm2.684 1.27c1.394.913 2.58 2.15 3.44 3.638a.7.7 0 0 1 0 .7 10.81 10.81 0 0 1-9.356 5.405c-1.138 0-2.252-.18-3.306-.52L9.88 16.15c.703.167 1.43.254 2.17.254a9.42 9.42 0 0 0 7.93-4.353 9.4 9.4 0 0 0-3.03-2.973zM15.5 10.52c.21.47.328.988.328 1.532a3.8 3.8 0 0 1-3.788 3.788 3.7 3.7 0 0 1-1.533-.328l1.1-1.1q.206.038.422.038c1.3 0 2.388-1.078 2.388-2.388q0-.216-.038-.422l1.11-1.1zm-1.37-2.586a9.4 9.4 0 0 0-10.02 4.118 9.4 9.4 0 0 0 2.968 2.935l1.472-1.472a3.8 3.8 0 0 1-.297-1.463c0-2.078 1.71-3.787 3.787-3.788a3.7 3.7 0 0 1 1.464.298zM12.386 9.69a2 2 0 0 0-.337-.024 2.407 2.407 0 0 0-2.388 2.388q0 .172.024.337l2.7-2.7z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHidei);
export default ForwardRef;